import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './MemberPurchase.css';
import Fade from 'react-reveal/Fade';
import { setDigitalData } from '../../Utilities/Utils.js';

class DGRMemberPurchase extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        if ( !this.props.DGRStore.values.member_number ) {
            this.props.history.push('/member/menu');
        } else if ( this.props.DGRStore.club_product_id === 'late_acceptance' && !this.props.DGRStore.values.signing_agreement_number ) {
            return this.props.history.push('/member/unavailable');
        }
        setDigitalData( 'member purchase', this.props.DGRStore.club_number );
/*
        const { club_product_id } = this.props.DGRStore;
        if ( club_product_id === 'easypay' || club_product_id === 'training_pin' ) {
            window.idleTimout = ( 15 * 1000 );
            window.idleReducedTimeout = ( 10 * 1000 );
            EventEmitter.emit('event:end_point_reached');
        } else {
            window.idleTimout = 210000;
            window.idleReducedTimeout = ( 1000 * 60 * 3 );
        }
    }

    componentWillUnmount() {
        window.idleTimout = 210000;
        window.idleReducedTimeout = ( 1000 * 60 * 3 );
*/
    }
    getFrameUrl() {
        const { club_number, club_product_id } = this.props.DGRStore
        const { member_number, first_name, last_name, signing_agreement_number } = this.props.DGRStore.values;
        var frameUrl = '';
        if ( club_product_id === 'buy_pt' ) {
            frameUrl += '/sales-redirect/salesredirect.html';
            frameUrl += '?flow=APOS_PT';
            frameUrl += '&availability=kiosk';
            frameUrl += '&clubId=' + club_number;
            frameUrl += '&memberId=' + member_number;
            frameUrl += '&system=Zuora';
        } else if ( club_product_id === 'add_family' ) {
            frameUrl += '/sales-redirect/salesredirect.html';
            frameUrl += '?flow=APOS_AO';
            frameUrl += '&availability=kiosk';
            frameUrl += '&clubId=' + club_number;
            frameUrl += '&memberId=' + member_number;
            frameUrl += '&system=Zuora';
        } else if ( club_product_id === 'easypay' ) {
            frameUrl += '/myaccount/easypay.html#/easypay';
        } else if ( club_product_id === 'training_pin' ) {
            frameUrl += '/myaccount/easypay.html/#/personalaccesscode/';
        } else if ( club_product_id === 'late_acceptance' && signing_agreement_number ) {
            frameUrl += '/membership/terms/?name=' + encodeURIComponent( first_name + ' ' + last_name ) + '&agreementNumber=' + signing_agreement_number + '&club=' + club_number;
        }

        return frameUrl;
    }

    render(){
        return (
            <Fade>
                <div id="framecontainer">
                    <iframe ref={this.FrameEl} title="Sales Flow" src={ this.getFrameUrl() }>
                    </iframe>
                </div>
            </Fade>
        )
    }
}

DGRMemberPurchase = inject('DGRStore', 'DGRBackgroundStore','DGRProductStore' )(observer(DGRMemberPurchase))
export default DGRMemberPurchase



// WEBPACK FOOTER //
// ./src/components/DGR/MemberPurchase/MemberPurchase.js